

















































































import Currency from "@/store/entities/currency";
import { Component, Vue } from "vue-property-decorator";
@Component({})
export default class AddCurrency extends Vue {
  isValid: boolean = false;
  dialog: boolean = true;
  isEdit: boolean = false;
  currency: Currency = new Currency();

  data() {
    return {
      title: "Preliminary report",
      email: "",
      rules: {
        required: (value) => !!value || "Zorunlu Alan.",
      },
    };
  }

  created() {
    this.currency = this.$store.state.currency.editCurrency;
    if (this.currency == null) {
      this.isEdit = false;
      this.currency = new Currency();
    } else {
      this.isEdit = true;
    }
  }

  async saveCurrency() {
    if (!this.isEdit) {
      await this.$store.dispatch({
        type: "currency/saveCurrency",
        data: this.currency,
      });

      Vue.$toast.success("Kayıt Eklendi");
      this.closeDialog();
    } else {
      await this.$store.dispatch({
        type: "currency/saveCurrency",
        data: this.currency,
      });

      Vue.$toast.success("Kayıt Güncellendi");

      this.closeDialog();
    }
  }

  closeDialog() {
    this.$emit("closed");
  }

  cancelDialog() {
    this.$emit("cancel");
    this.$store.state.currency.editCurrency = null;
  }
}
